import { red } from '@mui/material/colors'
import { components } from './components'
import { skSK } from '@mui/material/locale'

const themeOptions = {
	typography: {
		fontSize: 12,
		body1: {
			fontSize: '12px'
		}
	},

	status: {
		danger: red[500]
	},
	components: {
		...components
	},
	skSK
}

export default themeOptions
